import { ChartAxisOptions } from "../../config/type/chart-axes-options";

type WaveformAxis = Required<Pick<ChartAxisOptions, "visible" | "grid">>;

export type WaveformSeriesOptionsV1 = {
	xVisible: boolean;
	oplVisible: boolean;
};

export type WaveformSeriesOptions = {
	vibrationVisible: boolean;
	oplVisible: boolean;
};

export type WaveformChartOptions = {
	axes: {
		bottom: WaveformAxis;
		left: WaveformAxis;
	};
};

export type EventWaveformOptionsV1 = WaveformChartOptions & {
	waveformSeries: {
		xVisible: boolean;
		yVisible: boolean;
		zVisible: boolean;
		oplVisible: boolean;
	};
};

export type EventWaveformOptionsV2 = EventWaveformOptions;

export type EventWaveformOptions = WaveformChartOptions & {
	waveformSeries: WaveformSeriesOptions;
};

export const defaultEventWaveformOptions: EventWaveformOptions = {
	axes: {
		bottom: {
			visible: true,
			grid: true,
		},
		left: {
			visible: true,
			grid: true,
		},
	},
	waveformSeries: {
		vibrationVisible: true,
		oplVisible: false,
	},
};
